"use client";

import React from "react";
import { HEADER_V2_DESIGN_SYSTEM } from "@/components/header/v2/designTokens";

interface HeroSectionV2Props {
  carousel: React.ReactNode;
  promoComponent?: React.ReactNode;
}

const HeroSectionV2: React.FC<HeroSectionV2Props> = ({
  carousel,
  promoComponent,
}) => {
  return (
    <div className={`w-full max-w-7xl mx-auto mb-4 pt-2 md:pt-4 ${HEADER_V2_DESIGN_SYSTEM.spacing.containerPadding}`}>
      {/* 
        Responsive layout orchestration:
        - Mobile: flex-col, and we hide the promoComponent container using `hidden sm:block`.
        - Tablet: flex-col, stacked vertically.
        - Desktop: lg:flex-row, side-by-side (2/3 and 1/3 split).
      */}
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-2 items-stretch">
        
        {/* Carousel Slot (occupies 2/3 on desktop, 100% otherwise or when promoComponent is absent) */}
        <div className={`w-full transition-all duration-300 ${
          promoComponent ? "lg:w-2/3" : "lg:w-full"
        }`}>
          {/* Main Carousel Box with unified responsive aspect ratios and min-heights to prevent layout shifts */}
          <div className="w-full aspect-[16/9] lg:aspect-[20/9] min-h-[220px] md:min-h-[350px] lg:min-h-[381px]">
            {carousel}
          </div>
        </div>

        {/* Promo Slot (occupies 1/3 on desktop, completely hidden on mobile/tablet) */}
        {promoComponent && (
          <div className="w-full lg:w-1/3 hidden lg:block">
            {/* Promo card container that stretches to equal height of the Carousel on desktop */}
            <div className="w-full h-full aspect-[16/9] lg:aspect-[10/9] min-h-[220px] lg:min-h-[381px]">
              {promoComponent}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default React.memo(HeroSectionV2);
